export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'und',
'_.loadingSpinnerText': 'Bitte warten...',
'pageTimerMax.text': 'Nach Ablauf der Zeit wird automatisch zur nächsten Seite weitergeleitet.',
'pageTimerMax.timeLeft': 'Verbleibende Zeit',
'pageTimerMin.text': 'Vor Ablauf der Zeit ist keine Weiterleitung möglich.',
'pageTimerMin.timeLeft': 'Verbleibende Zeit',
'pageTimerMin.allowNext': 'Sie können weitergehen.',
'survey.registerForm.label.email': 'E-Mail',
'survey.registerForm.label.newsletter': 'Ich möchte den Newsletter erhalten.',
'survey.registerForm.label.regulations': 'Ich akzeptiere die Datenschutzrichtlinie und die Nutzungsbedingungen.',
'survey.registerForm.button.register': 'Registrieren',
'survey.registerForm.registered': 'Vielen Dank für Ihre Anmeldung. Eine E-Mail mit einem Aktivierungslink wurde an Ihre E-Mail-Adresse gesendet.',
'survey.registerForm.cardHeader': 'Registrieren Sie sich und erhalten Sie Punkte!',
'survey.registerForm.cardBody': 'Sie haben für die Teilnahme an der Umfrage erhalten',
'survey.registerForm.cardBody2': 'Die Punkte werden nach der Registrierung Ihres Kontos bei swpanel.pl gutgeschrieben. Geben Sie Ihre E-Mail-Adresse ein und registrieren Sie ein Konto bei swpanel.pl',
'survey.notProperDevice': 'Leider können Sie diese Umfrage auf diesem Gerät nicht ausfüllen.',
'survey.properDevices': 'Die Umfrage ist auf folgenden Geräten verfügbar:',
'survey.device-phone': 'Smartphone',
'survey.device-tablet': 'Tablet',
'survey.device-desktop': 'Computer / Laptop',
'nextSurveys.header.seeAlso': 'Sehen Sie sich auch andere Umfragen an',
'nextSurveys.button.fill': 'Ausfüllen',
'question.noContent': 'Kein Frageinhalt',
'question.input.placeholder.typeYourAnswer': 'Antwort eingeben',

'question.conjoint.go': 'Klicken Sie auf "Weiter"',
'question.matrix.carousel.go': 'Klicken Sie auf "Weiter"',
'question.carousel.prevBtn': 'Vorherige Aussage',
'question.carousel.nextBtn': 'Nächste Aussage',

'question.open.email.inputPlaceholder': 'Geben Sie Ihre E-Mail-Adresse ein',
'question.open.email.emailVerify.sendCode': 'Senden Sie den Bestätigungscode',
'question.open.email.emailVerify.enderCode': 'Geben Sie den erhaltenen Code ein',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Geben Sie den Code ein',
'question.open.email.emailVerify.confirm': 'Bestätigen',
'question.open.email.emailVerify.codeIncorrect': 'Der eingegebene Code ist ungültig',
'question.open.email.emailVerify.codeCorrect': 'E-Mail-Adresse erfolgreich verifiziert',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Ausfüllen unterbrechen',
'footer.buttonPrev.text': 'Zurück',
'footer.buttonClear.text': 'Löschen',
'footer.buttonNext.text': 'Weiter',
'footer.buttonEnd.text': 'Beenden',
'footer.buttonStart.text': 'Umfrage starten',
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',
};
